import { render, staticRenderFns } from "./view-thread.vue?vue&type=template&id=a30778ec&scoped=true"
import script from "./view-thread.vue?vue&type=script&lang=js"
export * from "./view-thread.vue?vue&type=script&lang=js"
import style0 from "./view-thread.vue?vue&type=style&index=0&id=a30778ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30778ec",
  null
  
)

export default component.exports